// extracted by mini-css-extract-plugin
export default {"AggregateLabels":"parent-issue-group-header-label-module__AggregateLabels--vOOGn","ParentIssueTitle":"parent-issue-group-header-label-module__ParentIssueTitle--q8oNS"};